var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"campaign-table-status-dates"},[_c('tbody',_vm._l((_vm.scheduleText),function(row,i){return _c('tr',{key:`scheduleText-${i}`},[(row.error)?_c('td',[_vm._v(_vm._s(row.error))]):_vm._l((row),function(cell,key){return _c('label' === key ? 'th' : 'td',{key:key,tag:"component"},[_vm._v(" "+_vm._s(cell)+" ")])})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }